import React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useKnowledgebase } from '../../Contexts/KnowledgebaseContext';

export default function HelpWidget() {
  const { openPanel, unreadReleaseNotes, helpWidgetRef } = useKnowledgebase();

  return (
    <Tooltip title="Help & Documentation">
      <IconButton
        ref={helpWidgetRef}
        color="inherit"
        aria-label="Open help and documentation"
        onClick={() => openPanel('search')}
        size="large"
      >
        <Badge
          color="error"
          variant="dot"
          invisible={!unreadReleaseNotes}
        >
          <HelpOutlineIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
